<template>
  <div>
    <div class="hzlist"><a @click="show = 0" :class="!show ? 'over' : '' ">淄博画展</a> <a  @click="show = 1" :class="show ? 'over' : '' ">军博画展</a></div>
		<div id="junbo" v-if="show">
			<div style="clear:both;margin:35px 0;">
        <iframe height=400 width=560 src='https://player.youku.com/embed/XMjM2ODMwMjIw' frameborder=0></iframe>
      </div>
		</div>
		<div id="junbo" v-else>
      <div style="clear:both;margin:35px 0;">
        <iframe height=400 width=560 src='https://player.youku.com/embed/XNzE0NzYxMTcy' frameborder=0></iframe>
      </div>
		</div>
  </div>
</template>

<script>
import finder from '../mock/finder.json'

export default {
  name: 'suiyue',
  data () {
    return {
      finder,
      show: 0
    }
  },
  computed: {
    product () {
      let product = this.finder.finder_message.filter(item => item.beizhu).reverse() || []
      return product
    }
  }
}
</script>
